// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2nALz","wrapper":"index-module--wrapper--35Svv"};